<template>
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />
    <div class="flex gap-10 items-center">
      <nav class="flex flex-col gap-y-4 xl:gap-y-0 w-full">
        <ul class="grid grid-flow-row cursor-pointer w-full">
          <li @click="activesubMenu('Discover')" class="flex w-full flex-col">
            <span
              class="text-lg font-semibold py-5 px-2 bg-gray-100 border-b-2 border-indigo-600"
              >Discover</span
            >
            <ul
              class="grid grid-flow-row w-full rounded-md pb-2 z-50 bg-white"
              v-if="openMenuDiscover"
              @click="openMenuDiscover = false"
            >
              <router-link
                to="/discover"
                class="flex items-center whitespace-no-wrap hover:bg-gray-200 duration-500 w-full"
                ><li class="p-3 text-sm whitespace-nowrap">
                  <span>{{ fb_ig_title_subtitle.title }}</span>
                </li>
              </router-link>

              <router-link
                to="/tiktoks"
                class="flex items-center whitespace-no-wrap"
              >
                <li
                  class="p-3 text-sm pr-10 hover:bg-gray-200 duration-500 w-full"
                >
                  <span>{{ tiktok_title_subtitle.title }}</span>
                </li>
              </router-link>

              <!-- <li
                class="p-3 text-sm pr-10 hover:bg-gray-200 duration-500 w-full"
              >
                <router-link
                  to="/top-brands"
                  class="flex items-center whitespace-no-wrap"
                >
                  <span>Top brands</span>
                </router-link>
              </li> -->

              <router-link
                to="/favorites"
                class="flex items-center whitespace-no-wrap"
                ><li
                  class="p-3 text-sm pr-10 hover:bg-gray-200 duration-500 w-full"
                >
                  <span>My Favorites</span>
                </li>
              </router-link>
            </ul>
          </li>
          <li @click="activesubMenu('Learn')" class="flex relative flex-col">
            <span
              class="text-lg font-semibold py-5 px-2 bg-gray-100 border-b-2 border-indigo-600"
              >Resources</span
            >
            <ul
              class="grid grid-flow-row w-full rounded-md pb-2 z-50 bg-white"
              v-if="openMenuLearn"
              @click="openMenuLearn = false"
            >
              <div>
                <router-link
                  to="/top-brands"
                  class="flex items-center whitespace-no-wrap"
                  ><li
                    class="p-3 text-sm pr-10 hover:bg-gray-200 duration-500 w-full"
                  >
                    <span>{{ top_brand_title_subtitle.title }}</span>
                  </li>
                </router-link>

                <router-link to="/ugc-creators" class="flex items-center"
                  ><li
                    class="p-3 text-sm pr-10 whitespace-no-wrap hover:bg-gray-200 duration-500"
                  >
                    <span>{{ ugc_creator_title_subtitle.title }}</span>
                  </li>
                </router-link>

                <router-link
                  to="/hooks"
                  class="flex items-center whitespace-no-wrap"
                >
                  <li class="p-3 text-sm pr-10 hover:bg-gray-200 duration-500">
                    <span>{{ hooks_title_subtitle.title }}</span>
                  </li>
                </router-link>

                <!-- <li
                  @click="activesubMenu('Learn')"
                  class="p-3 text-sm pr-10 hover:bg-gray-200 duration-500"
                >
                  <router-link
                    to="/frameworks"
                    class="flex items-center whitespace-no-wrap"
                  >
                    <span>Frameworks</span>
                  </router-link>
                </li> -->
                <router-link
                  to="/calendar"
                  class="flex items-center whitespace-no-wrap"
                >
                  <li class="p-3 text-sm pr-10 hover:bg-gray-200 duration-500">
                    <span>{{ calendar_title_subtitle.title }}</span>
                  </li>
                </router-link>
              </div>
              <div>
                <router-link
                  to="/ads-test-first"
                  class="flex items-center whitespace-no-wrap"
                >
                  <li class="p-3 text-sm pr-10 hover:bg-gray-200 duration-500">
                    <span>{{ ads_test_first_title_subtitle.title }}</span>
                  </li>
                </router-link>

                <router-link to="/psychology" class="flex items-center">
                  <li
                    class="p-3 text-sm pr-10 whitespace-no-wrap hover:bg-gray-200 duration-500"
                  >
                    <span>{{ psycology_title_subtitle.title }}</span>
                  </li>
                </router-link>

                <router-link to="/case-studies" class="flex items-center">
                  <li
                    class="p-3 text-sm pr-10 whitespace-no-wrap hover:bg-gray-200 duration-500"
                  >
                    <span>{{ case_study_title_subtitle.title }}</span>
                  </li>
                </router-link>

                <router-link to="/deals-and-tools" class="flex items-center">
                  <li
                    class="p-3 text-sm pr-10 whitespace-no-wrap hover:bg-gray-200 duration-500"
                  >
                    <span>{{ deals_tools_title_subtitle.title }}</span>
                  </li>
                </router-link>
              </div>
            </ul>
          </li>
          <li
            v-if="
              ((role == 'free' || role == 'monthly' || role == 'annual') &&
                !status) ||
                role == 'monthly'
            "
            class="flex w-full"
          >
            <router-link to="/pricing" class="flex items-center w-full">
              <span
                class="w-full text-lg font-semibold py-5 px-2 bg-gray-100 border-b-2 border-indigo-600"
                >Pricing</span
              >
            </router-link>
          </li>
          <!-- <li v-if="status" class=" flex items-center w-full">
            <a
              href="https://adbox.getrewardful.com/signup"
              target="_blank"
              class=" flex items-center w-full"
              ><span
                class="w-full text-lg font-semibold py-5 px-2 bg-gray-100 border-b-2 border-indigo-600"
                >Become an Affiliate</span
              >
            </a>
          </li>
          <li v-else class=" flex items-center w-full no-click">
            <a
              href="https://adbox.getrewardful.com/signup"
              target="_blank"
              class=" flex items-center w-full"
              ><span
                class="w-full text-lg font-semibold py-5 px-2 bg-gray-100 border-b-2 border-indigo-600"
                >Become an Affiliate</span
              >
            </a>
          </li>-->
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, ref } from "vue";
import HeaderApp from "@/components/Header";
export default {
  components: { HeaderApp },

  setup() {
    const openMenuDiscover = ref(false);
    const openMenuLearn = ref(false);
    const openMenuUser = ref(false);
    const signoutVisible = ref(false);

    const activesubMenu = (value) => {
      if (value === "Discover" && status.value) {
        openMenuLearn.value = false;
        openMenuUser.value = false;
        openMenuDiscover.value = !openMenuDiscover.value;
      } else if (value === "Learn" && status.value) {
        openMenuDiscover.value = false;
        openMenuUser.value = false;
        openMenuLearn.value = !openMenuLearn.value;
      } else {
        openMenuDiscover.value = false;
        openMenuLearn.value = false;
        openMenuUser.value = !openMenuUser.value;
      }
    };
    const store = useStore();
    const status = computed(() => store.state.status);
    const user = computed(() => store.state.user);
    const role = computed(() => store.state.role);

    const fb_ig_title_subtitle = computed(() => store.state.fbIgTitleSubtitle);
    const tiktok_title_subtitle = computed(
      () => store.state.tiktokTitleSubtitle
    );
    const hooks_title_subtitle = computed(() => store.state.hooksTitleSubtitle);
    const top_brand_title_subtitle = computed(
      () => store.state.topBrandTitleSubtitle
    );
    const calendar_title_subtitle = computed(
      () => store.state.calendarTitleSubtitle
    );
    const ads_test_first_title_subtitle = computed(
      () => store.state.adsToTestFirstTitleSubtitle
    );
    const psycology_title_subtitle = computed(
      () => store.state.psycologyTitleSubtitle
    );
    const case_study_title_subtitle = computed(
      () => store.state.caseStudiesTitleSubtitle
    );
    const deals_tools_title_subtitle = computed(
      () => store.state.dealsToolsTitleSubtitle
    );
    const ugc_creator_title_subtitle = computed(
      () => store.state.ugcCreatorsTitleSubtitle
    );

    return {
      status,
      user,
      role,
      fb_ig_title_subtitle,
      tiktok_title_subtitle,
      top_brand_title_subtitle,
      hooks_title_subtitle,
      calendar_title_subtitle,
      ads_test_first_title_subtitle,
      psycology_title_subtitle,
      case_study_title_subtitle,
      deals_tools_title_subtitle,
      ugc_creator_title_subtitle,
      openMenuDiscover,
      openMenuLearn,
      openMenuUser,
      activesubMenu,
      signoutVisible,
    };
  },
};
</script>

<style>
.no-click {
  pointer-events: none;
}
</style>
